// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.x5T5fgyyCpXccD {
  height: 64px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
.W21VDtqqicaQTk {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  -webkit-user-select: none;
          user-select: none;
}
.poJEm5jOqvfcdA {
  height: 36px;
  overflow: hidden;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
.poJEm5jOqvfcdA.oLdCqmMZyNDCUT {
  position: relative;
  background-color: var(--ds-background-accent-green-subtle, #4bce97);
  color: var(--ds-text-accent-green-bolder, #164b35);
}
.body-color-blind-mode-enabled .poJEm5jOqvfcdA.oLdCqmMZyNDCUT::before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 16px;
  border-radius: 4px 0px 0px 4px;
  mask-repeat: repeat-y;
}
.poJEm5jOqvfcdA.PUxjJ75cqOBDMF {
  position: relative;
  background-color: var(--ds-background-accent-yellow-subtle, #e2b203);
  color: var(--ds-text-accent-yellow-bolder, #533f04);
}
.body-color-blind-mode-enabled .poJEm5jOqvfcdA.PUxjJ75cqOBDMF::before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 16px;
  border-radius: 4px 0px 0px 4px;
  mask-repeat: repeat-y;
}
.poJEm5jOqvfcdA.CDeS14JEyB0sMi {
  position: relative;
  background-color: var(--ds-background-accent-orange-subtle, #faa53d);
  color: var(--ds-text-accent-orange-bolder, #5f3811);
}
.body-color-blind-mode-enabled .poJEm5jOqvfcdA.CDeS14JEyB0sMi::before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 16px;
  border-radius: 4px 0px 0px 4px;
  mask-repeat: repeat-y;
}
.poJEm5jOqvfcdA.Tnp5FUAge8Jtl_ {
  position: relative;
  background-color: var(--ds-background-accent-red-subtle, #f87462);
  color: var(--ds-text-accent-red-bolder, #601e16);
}
.body-color-blind-mode-enabled .poJEm5jOqvfcdA.Tnp5FUAge8Jtl_::before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 16px;
  border-radius: 4px 0px 0px 4px;
  mask-repeat: repeat-y;
}
.poJEm5jOqvfcdA.vLg117I98uBkYx {
  position: relative;
  background-color: var(--ds-background-accent-purple-subtle, #9f8fef);
  color: var(--ds-text-accent-purple-bolder, #352c63);
}
.body-color-blind-mode-enabled .poJEm5jOqvfcdA.vLg117I98uBkYx::before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 16px;
  border-radius: 4px 0px 0px 4px;
  mask-repeat: repeat-y;
}
.poJEm5jOqvfcdA.PJO7FpCBxTQJJi {
  position: relative;
  background-color: var(--ds-background-accent-blue-subtle, #579dff);
  color: var(--ds-text-accent-blue-bolder, #09326c);
}
.body-color-blind-mode-enabled .poJEm5jOqvfcdA.PJO7FpCBxTQJJi::before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 16px;
  border-radius: 4px 0px 0px 4px;
  mask-repeat: repeat-y;
}
.poJEm5jOqvfcdA.Vns7ZQ7oQm1gqR {
  position: relative;
  background-color: var(--ds-background-accent-teal-subtle, #60c6d2);
  color: var(--ds-text-accent-teal-bolder, #1d474c);
}
.body-color-blind-mode-enabled .poJEm5jOqvfcdA.Vns7ZQ7oQm1gqR::before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 16px;
  border-radius: 4px 0px 0px 4px;
  mask-repeat: repeat-y;
}
.poJEm5jOqvfcdA.haZCynNFvF4r0m {
  position: relative;
  background-color: var(--ds-background-accent-lime-subtle, #94c748);
  color: var(--ds-text-accent-lime-bolder, #5b7f24);
}
.body-color-blind-mode-enabled .poJEm5jOqvfcdA.haZCynNFvF4r0m::before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 16px;
  border-radius: 4px 0px 0px 4px;
  mask-repeat: repeat-y;
}
.poJEm5jOqvfcdA.d0p7y0U1nuF1Fd {
  position: relative;
  background-color: var(--ds-background-accent-magenta-subtle, #e774bb);
  color: var(--ds-text-accent-magenta-bolder, #5b7f24);
}
.body-color-blind-mode-enabled .poJEm5jOqvfcdA.d0p7y0U1nuF1Fd::before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 16px;
  border-radius: 4px 0px 0px 4px;
  mask-repeat: repeat-y;
}
.poJEm5jOqvfcdA.WEIU2dCN80l8zB {
  position: relative;
  background-color: var(--ds-background-accent-gray-subtle, #8590a2);
  color: var(--ds-text-accent-gray-bolder, #091e42);
}
.body-color-blind-mode-enabled .poJEm5jOqvfcdA.WEIU2dCN80l8zB::before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 16px;
  border-radius: 4px 0px 0px 4px;
  mask-repeat: repeat-y;
}
.poJEm5jOqvfcdA.woDwKgvnWsDdO8 {
  height: 64px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"emptyCover": `x5T5fgyyCpXccD`,
	"cardFrontImageCover": `W21VDtqqicaQTk`,
	"cardFrontCover": `poJEm5jOqvfcdA`,
	"green": `oLdCqmMZyNDCUT`,
	"yellow": `PUxjJ75cqOBDMF`,
	"orange": `CDeS14JEyB0sMi`,
	"red": `Tnp5FUAge8Jtl_`,
	"purple": `vLg117I98uBkYx`,
	"blue": `PJO7FpCBxTQJJi`,
	"sky": `Vns7ZQ7oQm1gqR`,
	"lime": `haZCynNFvF4r0m`,
	"pink": `d0p7y0U1nuF1Fd`,
	"black": `WEIU2dCN80l8zB`,
	"hasStickers": `woDwKgvnWsDdO8`
};
export default ___CSS_LOADER_EXPORT___;
